import { EPageTypeGetParam } from '@/enums/EPageTypeGetParam';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_navigate_ud } from '@/hooks/_base/use_navigate_ud';
import { UTILS__url } from '@/utils/UTILS__url';

export function WATCHER_SLUG__remove_grid2d_offset() {
  const navigate = use_navigate_ud();
  /*
   * EFFECTS
   */

  use_effect(() => {
    const url_new = UTILS__url.delete(EPageTypeGetParam.GRID2D_OFFSET);

    void navigate(url_new);
  }, []);

  return null;
}
